import { IMotorInsuranceInitialValues } from '../../types';

export const INITIAL_VALUES: IMotorInsuranceInitialValues = {
  id: undefined,
  upload_files: [],
  branch: [],
  email_users: [],
  organization: 0,
  policy_number: '',
  start_date: '',
  end_date: '',
  description: '',
  license_plate: '',
  recent_status: '',
};
